import script from "./ProductHardDetailEN.vue?vue&type=script&setup=true&name=ProductHardDetailEN&lang=js"
export * from "./ProductHardDetailEN.vue?vue&type=script&setup=true&name=ProductHardDetailEN&lang=js"

import "./ProductHardDetailEN.vue?vue&type=style&index=0&id=42b41382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b41382"]])

export default __exports__